import { SEVERITY } from 'constants/ChecklistConstants';

import type { ChecklistAdviceForm, ChecklistForm, ChecklistItemForm } from 'services/ChecklistUtils';
import { createNewAdvice, createNewChecklist, createNewItem } from 'services/ChecklistUtils';
import { computeValueWithVAT } from 'services/VATUtils';

type ChecklistAdviceFormWithVat = ChecklistAdviceForm & { priceWithVat: number };
type ChecklistItemFormWithVat = Omit<ChecklistItemForm, 'advices'> & { advices?: ChecklistAdviceFormWithVat[] };
type ChecklistFormWithVat = Omit<Partial<ChecklistForm>, 'items'> & { items?: ChecklistItemFormWithVat[] };

export const getEmptyChecklist = (params: Partial<ChecklistForm> = {}): ChecklistForm => ({
  ...createNewChecklist(),
  items: [
    {
      ...createNewItem(undefined, false),
      advices: [createNewAdvice(SEVERITY.UNDEFINED)],
    },
  ],
  ...params,
});

export const formatWithVat = (
  checklist?: Partial<ChecklistForm>,
  vat?: number
): ChecklistFormWithVat | Partial<ChecklistForm> => {
  const items = checklist?.items?.map(item => ({
    ...item,
    advices: item?.advices?.map(advice => ({ ...advice, priceWithVat: computeValueWithVAT(advice.price, vat) })),
  }));

  return {
    ...checklist,
    ...(items ? { items } : {}),
  };
};
